module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOS41IiBjeT0iOS41IiByPSI5IiBzdHJva2U9ImJsYWNrIi8+CjxsaW5lIHgxPSI5LjYzMzc5IiB5MT0iNC41IiB4Mj0iOS42MzM3OSIgeTI9IjE0LjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8bGluZSB4MT0iNC41IiB5MT0iOS4zNjY3IiB4Mj0iMTQuNSIgeTI9IjkuMzY2NyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/plus-icon.svg
// module id = 21
// module chunks = 1